import { render, staticRenderFns } from "./CollectionCategoryImages.vue?vue&type=template&id=9f8b0668&scoped=true&lang=pug&"
import script from "./CollectionCategoryImages.vue?vue&type=script&lang=js&"
export * from "./CollectionCategoryImages.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCategoryImages.vue?vue&type=style&index=0&id=9f8b0668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8b0668",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f8b0668')) {
      api.createRecord('9f8b0668', component.options)
    } else {
      api.reload('9f8b0668', component.options)
    }
    module.hot.accept("./CollectionCategoryImages.vue?vue&type=template&id=9f8b0668&scoped=true&lang=pug&", function () {
      api.rerender('9f8b0668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionCategoryImages.vue"
export default component.exports